import React from 'react';
import { Price } from '../containers/commerce';

export default () => (
  <React.Fragment>
    Retunér dine fustager til fuld pris minus <Price varenr="641" /> pr. stk.
  </React.Fragment>
);
